import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FreePlanRegister.css';

const FreePlanRegister = ({ onContinue }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSubscribeClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    // Navigate to register page with free plan state
    navigate('/register', { state: { plan: 'free' } });
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="pricing-card basic">
        <img
          src="https://cdn-icons-png.flaticon.com/512/6280/6280269.png"
          alt="Encouragement"
          className="encourage-img"
        />
        <h2>Gratuit</h2>
        <p className="price">0€ / mois</p>
        <ul id='centered-list' className="centered-list" style={{
          width: 'fit-content', /* Or a specific pixel value, e.g., '300px' */
          margin: '0 auto',     /* This centers it horizontally */
          listStyle: 'none',    /* Optional: To remove default bullet points */
          padding: '0'          /* Optional: To remove default padding */
        }}>
          <li><span className="checkmark">✔</span> Accès limité aux prompts</li>
          <li><span className="checkmark">✔</span> Interface intuitive</li>
          <li><span className="cross">✖</span> Support vocal</li>
          <li><span className="cross">✖</span> Historique sauvegardé</li>
        </ul>
          <br></br>
            <br></br>
              <br></br>
             
        <button onClick={handleSubscribeClick}>S'inscrire</button>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Bienvenue dans RapidMind AI 🎉</h3>
            <p>Votre plan gratuit inclut :</p>
            <ul className="modal-list">
              <li>✅ 10 requêtes AI par jour</li>
              <li>✅ Interface intuitive et rapide</li>
              <li>✅ Accès aux prompts essentiels</li>
              <li>✅ Thème sombre activable</li>
            </ul>
            <p className="small-text">C’est 100% gratuit. Vous pourrez toujours passer à un plan supérieur plus tard.</p>
            <div className="modal-actions">
              <button className="confirm" onClick={handleConfirm}>Créer mon compte gratuit</button>
              <button className="cancel" onClick={handleClose}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FreePlanRegister;
